import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-social-button',
    templateUrl: './social-button.component.html',
    styleUrls: ['./social-button.component.scss']
})
export class SocialButtonComponent implements OnInit {
    @Input() type: string;
    @Input() value: string;
    facebook:boolean;
    twitter:boolean;
    youtube:boolean;

    constructor() { }

    ngOnInit(): void {
        this.facebook = (this.type === 'facebook')
        this.twitter = (this.type === 'twitter')
        this.youtube = (this.type === 'youtube')
    }

    open(){
        window.open(this.value, "_blank");
    }

}
